import * as React from "react"

import { cn } from "@/lib/utils"

// PLACEHOLDER TONU: örnek metinler ("Bridgestone", "205/55 R16", "2823")
// gerçek girilmiş değer gibi okunmamalı. muted-foreground'un %45 opaklığı
// gövde metninden belirgin şekilde soluk kalır; gerçek `value` rengine
// DOKUNULMAZ. Aynı ton textarea ve select placeholder'ında da kullanılır.
const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground/45 placeholder:font-normal focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
